// extracted by mini-css-extract-plugin
export default {"container":"notFound_container__aakYm","back":"notFound_back__RP+Q5","body":"notFound_body__m+2g+","slide-in-bottom":"notFound_slide-in-bottom__KhnfH"};